import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Terminal, Activity, Eye } from "lucide-react";
import { useEffect, useRef } from "react";
export default function LEnjeuDeMuna() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const badgeRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-badge-in");
        }
      });
    }, {
      threshold: 0.1
    });
    if (badgeRef.current) observer.observe(badgeRef.current);
    const handleScroll = () => {
      if (!parallaxRef.current) return;
      const scrolled = window.scrollY;
      const offsetTop = parallaxRef.current.offsetTop;
      const val = (scrolled - offsetTop) * 0.15;
      parallaxRef.current.style.setProperty("--parallax-y", `${val}px`);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section data-section-id="223468" id="la-vision-smilegeeks" className="bg-background text-foreground relative w-full overflow-hidden selection:bg-primary selection:text-primary-foreground">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes glitch {
          0% { transform: translate(0); }
          20% { transform: translate(-2px, 2px); }
          40% { transform: translate(-2px, -2px); }
          60% { transform: translate(2px, 2px); }
          80% { transform: translate(2px, -2px); }
          100% { transform: translate(0); }
        }
        @keyframes scanline {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(100%); }
        }
        @keyframes badge-in {
          from { opacity: 0; transform: scale(0.8); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-float { animation: float 6s ease-in-out infinite; }
        .animate-glitch:hover { animation: glitch 0.3s cubic-bezier(.25,.46,.45,.94) both infinite; }
        .animate-badge-in { animation: badge-in 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
        .neon-border {
          box-shadow: 0 0 15px rgba(0, 240, 255, 0.3), inset 0 0 15px rgba(139, 92, 246, 0.3);
          border: 1px solid rgba(0, 240, 255, 0.2);
        }
        .scanline-overlay::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, transparent, rgba(0, 240, 255, 0.1) 50%, transparent);
          height: 100px;
          width: 100%;
          z-index: 20;
          pointer-events: none;
          animation: scanline 4s linear infinite;
        }
      `
    }} />

      <div className="grid grid-cols-1 lg:grid-cols-2 relative min-h-screen">
        
        {}
        <div className="relative h-[60vh] lg:h-screen lg:sticky lg:top-0 overflow-hidden border-b lg:border-b-0 lg:border-r border-border/50 bg-black group">
          
          <div ref={parallaxRef} className="relative w-full h-full transition-transform duration-100 ease-out will-change-transform" style={{
          transform: 'translateY(var(--parallax-y, 0))'
        }}>
            <div className="absolute inset-4 md:inset-8 lg:inset-12 overflow-hidden rounded-lg neon-border animate-float animate-glitch scanline-overlay">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/robot_dev_screen.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/robot_dev_screen.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/robot_dev_screen.png-wvc-sizes" alt="Robot interface displaying development code" className="absolute inset-0 object-cover w-full h-full grayscale contrast-125 brightness-90 transition-all duration-700 group-hover:scale-110 group-hover:grayscale-0 group-hover:contrast-100 group-hover:brightness-100" loading="lazy" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/automation_community_interface.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/automation_community_interface.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/automation_community_interface.png-wvc-sizes" alt="Digital screen showing community management and automation" className="absolute inset-0 object-cover w-full h-full grayscale contrast-125 brightness-90 transition-all duration-700 opacity-0 group-hover:opacity-100 group-hover:scale-110 group-hover:grayscale-0 group-hover:contrast-100 group-hover:brightness-100" loading="lazy" />
            </div>
          </div>
          
          {}
          <div className="absolute inset-0 opacity-30 mix-blend-overlay pointer-events-none" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
        }} />

          {}
          <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.2)_50%)] bg-[length:100%_4px] pointer-events-none opacity-30" />

          {}
          <div ref={badgeRef} className="absolute top-6 left-6 flex items-center gap-2 text-primary font-mono text-xs tracking-widest uppercase bg-background/80 backdrop-blur-sm px-3 py-1.5 border border-primary/30 opacity-0 scale-75">
            <Activity className="size-4 animate-pulse" />
            <span>Statut: Fondateur</span>
          </div>
          
          <div className="absolute bottom-6 right-6 flex items-center gap-2 text-muted-foreground font-mono text-xs tracking-widest uppercase">
            <Eye className="size-4" />
            <span>Vision Digitale - 2024</span>
          </div>
        </div>

        {}
        <div className="relative p-8 md:p-16 lg:p-24 flex flex-col justify-center min-h-screen bg-background">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/digital_strategy_visual.png" alt="Digital Strategy Visualization" className="w-4/5 mx-auto mb-12 rounded-lg opacity-80 grayscale hover:grayscale-0 transition-all duration-700" />
          
          {}
          <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
            <div className="absolute top-0 left-[-10%] w-[120%] h-[120%] bg-[radial-gradient(ellipse_at_center,var(--color-secondary)_0%,transparent_70%)] blur-[120px] animate-[pulse_8s_ease-in-out_infinite]" />
            <div className="absolute bottom-[-20%] right-[-10%] w-[80%] h-[80%] bg-[radial-gradient(ellipse_at_center,var(--color-primary)_0%,transparent_70%)] blur-[150px] opacity-30 animate-[pulse_12s_ease-in-out_infinite_reverse]" />
          </div>

          <div className="relative z-10 max-w-2xl mx-auto w-full space-y-20">
            
            {}
            <div className="flex items-center gap-3 text-muted-foreground border-b border-border/50 pb-4">
              <Terminal className="size-5" />
              <span className="font-mono text-sm tracking-widest uppercase">Philosophy_Manifesto.v1</span>
            </div>

            {}
            <div className="space-y-6">
              <p className="font-default text-muted-foreground leading-relaxed text-base md:text-lg text-justify">
                Le marketing digital n'est pas une simple question d'algorithmes, c'est une science de l'attention. Chez Smilegeeks, nous transformons la complexité technique en opportunités de croissance. Mon parcours de CEO est guidé par une obsession : l'excellence opérationnelle au service de l'impact humain.
              </p>
            </div>

            {}
            <div className="relative pl-8 md:pl-12 border-l-2 border-primary py-4">
              <div className="absolute top-0 left-0 w-2 h-full bg-primary/10" />
              <p className="font-default text-2xl md:text-4xl lg:text-5xl text-foreground font-bold leading-tight tracking-tight">
                "L'innovation n'est pas une option, c'est le moteur de chaque stratégie que nous déployons."
                <span className="inline-block w-3 h-[1em] bg-primary ml-2 align-middle animate-[pulse_1s_step-end_infinite]" />
              </p>
            </div>

            {}
            <div className="space-y-6">
              <p className="font-default text-muted-foreground leading-relaxed text-base md:text-lg text-justify">
                Du SEO à l'Automation, chaque levier est une pièce d'un écosystème plus vaste. Nous ne nous contentons pas de suivre les tendances ; nous intégrons l'IA pour anticiper les besoins de demain et redéfinir les standards de l'industrie digitale.
              </p>
            </div>

            {}
            <div className="relative pl-8 md:pl-12 border-l-2 border-secondary py-4">
              <p className="font-default text-2xl md:text-4xl lg:text-5xl text-foreground font-bold leading-tight tracking-tight">
                "La technologie doit amplifier l'intelligence humaine, jamais la remplacer."
                <span className="inline-block w-3 h-[1em] bg-secondary ml-2 align-middle animate-[pulse_1s_step-end_infinite_0.5s]" />
              </p>
            </div>

            {}
            <div className="space-y-6">
              <p className="font-default text-muted-foreground leading-relaxed text-base md:text-lg text-justify">
                Smilegeeks est née d'une vision : celle d'une agence où la data rencontre la créativité. Mon rôle est de piloter cette synergie pour offrir à nos partenaires une visibilité sans précédent dans un monde saturé d'informations.
              </p>
            </div>

            {}
            <div className="pt-12 border-t border-border/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
                Fin de présentation.
              </div>
              <Button asChild variant="outline" className="font-mono uppercase tracking-widest border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                <Link to="https://smile-geek.com/">
                  Découvrir l'Agence
                </Link>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>;
}